import Axios from 'axios';

const getDefaultState = () => {
  return {
    smStatusesLoaded: false,
    smStatusesLoading: false,
    smStatuses: [],
    smFilterStatusesLoaded: [],
    smFilterStatuses: []
  };
};

const state = getDefaultState();

const getters = {};

const mutations = {
  SET_STATUSES_LOADED: (state, payload) => {
    state.smStatusesLoaded = payload;
  },

  SET_STATUSES_LOADING: (state, payload) => {
    state.smStatusesLoading = payload;
  },

  SET_STATUSES: (state, payload) => {
    state.smStatuses = payload;
  },

  SET_FILTER_STATUSES_LOADED: (state, payload) => {
    state.smFilterStatusesLoaded = payload;
  },

  SET_FILTER_STATUSES: (state, payload) => {
    state.smFilterStatuses = payload;
  }
};

const actions = {
  async fetchSportmasterStatuses({ commit }, responseId) {
    commit('SET_STATUSES_LOADING', true);
    commit('SET_STATUSES', []);

    let url = `1.0/spec-private/sportmaster/response-statuses`;

    if (responseId !== undefined) {
      url = `1.0/spec-private/sportmaster/response-statuses?response_id=${responseId}`;
    }

    await Axios.get(url)
      .then(x => {
        if (x.status === 200) {
          commit('SET_STATUSES', x.data.data);
          commit('SET_STATUSES_LOADED', true);
        }
      })
      .finally(() => {
        commit('SET_STATUSES_LOADING', false);
      });
  },

  async fetchSmFilterStatuses({ commit }, responseId) {
    commit('SET_STATUSES_LOADING', true);
    commit('SET_FILTER_STATUSES', []);

    let url = `1.0/spec-private/sportmaster/response-statuses`;

    if (responseId !== undefined) {
      url = `1.0/spec-private/sportmaster/response-statuses?response_id=${responseId}`;
    }

    await Axios.get(url)
      .then(x => {
        if (x.status === 200) {
          commit('SET_FILTER_STATUSES', x.data.data);
          commit('SET_FILTER_STATUSES_LOADED', true);
        }
      })
      .finally(() => {
        commit('SET_STATUSES_LOADING', false);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
